import { createId } from "../../app/runtimeContext";
import type { ProductContext, RequestInterpretation } from "./liveTypes";

export class RequestInterpreter {
  interpret(input: {
    message: string;
    context: ProductContext;
    conversationId: string;
  }): RequestInterpretation {
    const lower = input.message.toLowerCase();
    const destructive = [
      "delete",
      "drop",
      "deploy production",
      "charge",
      "stripe",
      "secret",
    ].some((term) => lower.includes(term));
    const missingInformation =
      input.message.trim().length < 12
        ? ["Request is too short to create executable work."]
        : [];
    const confidence = destructive
      ? 82
      : missingInformation.length > 0
        ? 65
        : 91;
    return {
      id: createId("interpretation"),
      organizationId: input.context.organizationId,
      productId: input.context.productId,
      conversationId: input.conversationId,
      interpretedObjective: input.message.trim(),
      requestedOutcome: `Create an owner-reviewed plan for ${input.context.productName}.`,
      constraints: [
        "Owner approval required before execution",
        "No external tools execute in Sprint 7",
      ],
      knownDecisions: [],
      missingInformation,
      assumptions:
        confidence < 95
          ? ["Cyan prepared a plan with explicit assumptions for owner review."]
          : [],
      affectedSystems: [input.context.productName, "SS Core runtime"],
      requiredDepartments: ["Executive", "Technology"],
      estimatedRisk: destructive ? "high" : "medium",
      estimatedCostCategory: "low",
      approvalRequirement: destructive ? "destructive" : "plan",
      confidence,
      shouldAskClarifyingQuestion: confidence < 80,
    };
  }
}
